import React, { useEffect, useCallback, useState } from 'react';
import IndustryList from './IndustryList'
import { authProvider } from '../../authProvider';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import axios from 'axios';



function IndustryManager() {

    const [industries, setIndustries] = useState([]);
    const [editedIndustry, setEditedIndustry] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);

    const addIndustry = useCallback(() => {
        setIndustries([...industries, { id: 0, name: "" }]);
    }, [industries, setEditedIndustry]);
    const editIndustry = useCallback((ind) => {
        setEditedIndustry(ind);
    }, [setEditedIndustry]);
    const updateIndustry = useCallback((updatedInd) => {
        setIndustries(industries.map((ind) => {
            if (ind.id == editedIndustry.id) {
                setHasChanges(true);
                ind.hasChanges = true;
                return editedIndustry;
            }
            return ind;
        }));
    }, [industries, editedIndustry, setHasChanges]);
    const saveIndustries = useCallback(async () => {
        var modifiedInds = industries.filter((ind) => { return ind.hasChanges && ind.name;  });

        // Save industries;
        var result = await authProvider.getAccessToken();
        var tkn = result.accessToken
        if (tkn) {
            var hdrs = { 'Authorization': "Bearer " + tkn };

            // Load Industries
            var res = await axios.post(rootUrl + "Industry", modifiedInds, { headers: hdrs });
            if (res.data) {
                setIndustries(res.data);
            }

        }
    }, [industries, setIndustries])
    const cbItems = [
        {
            key: 'newItem',
            text: 'Add Industry',
            iconProps: { iconName: 'Add' },
            onClick: addIndustry
        },
        {
            key: 'saveItem',
            text: "Save",
            disabled: !hasChanges,
            iconProps: { iconName: 'Save' },
            onClick: saveIndustries
        }
    ];

    var rootUrl = window.location.protocol + '//' + window.location.host + '/';
    const initState = {
        industries: [],
        editedIndustry: null,
    }



    const loadIndustries = useCallback(async () => {

        var result = await authProvider.getAccessToken();
        var tkn = result.accessToken
        if (tkn) {
            var hdrs = { 'Authorization': "Bearer " + tkn };

            // Load Industries
            var res = await axios.get(rootUrl + "Industry", { headers: hdrs })
            if (res.data) {
                setIndustries(res.data);
            }

        }

    }, [setIndustries]);

    useEffect(() => {
        (async () => {
            await loadIndustries();
        })();
    }, [loadIndustries]);



    let editorPane = <IndustryList industries={industries} editedIndustry={editedIndustry} onAddIndustry={addIndustry} onEditIndustry={editIndustry} onUpdateIndustry={updateIndustry} onSaveIndustries={saveIndustries} />;
    //if (editedIndustry) {
    //    editorPane = <IndustryEditor />
    //}
    //else {
    //    editorPane = <IndustryList />
    //}
    return (
        <div className="container">
            <h1>Manage Industries</h1>
            <CommandBar items={cbItems} />
            {editorPane}
        </div>
    )
}

export default IndustryManager;